import React from 'react';
import PropTypes from 'prop-types';

// Components
import Puller from "./Puller";

// Assets
import {black500, greyishBlue100, greyishBlue500} from "assets/jss/main";
import {ReactComponent as CloseIcon} from "assets/img/wms/close_medium.svg";
import {Grid} from "@mui/material";

BottomDrawerHead.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClose: PropTypes.func,
};

function BottomDrawerHead({title, subtitle, onClose, children}) {
    return (
        <Grid
            container
            direction={'column'}
            sx={{
                background: '#fff',
                width: '100%',
                position: 'sticky',
                top: 0,
                padding: '24px 44px 16px 16px',
                borderBottom: `1px solid ${greyishBlue100}`,
                zIndex: 1
            }}
        >
            <Grid
                item
                sx={{
                    background: '#fff',
                    position: 'absolute',
                    top: 0,
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    visibility: 'visible',
                    right: 0,
                    left: 0,
                }}
            >
                <Puller />
            </Grid>
            <Grid
                item
                sx={{
                    position: 'absolute',
                    top: 20,
                    right: 20,
                }}
            >
                <CloseIcon onClick={() => onClose()} />
            </Grid>
            <Grid
                container
                direction={'column'}
            >
                <Grid
                    item
                    sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: black500
                    }}
                >
                    {title}
                </Grid>
                <Grid
                    item
                    sx={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: greyishBlue500,
                    }}
                >
                    {subtitle}
                </Grid>
            </Grid>
            {children && (
                <Grid
                    item
                    sx={{marginTop: "20px"}}
                >
                    {children}
                </Grid>
            )}
        </Grid>
    );
}

export default BottomDrawerHead;
